import React from 'react';
import QueueAnim from 'rc-queue-anim';
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '../utils';
import '../../CSS/style.css';

class Content extends React.PureComponent {

  selectTab = () => {
    sessionStorage.setItem("activeTab","客户案例")
  };
  render() {
    const { dataSource, isMobile, ...props } = this.props;
    const {
      wrapper,
      titleWrapper,
      page,
      OverPack: overPackData,
      childWrapper,
    } = dataSource;


    return (
      <div {...props} {...wrapper} style={{ background: '#fff'}}>
        <div {...page}>
          <div {...titleWrapper} style={{fontSize:16,color:'rgba( 0, 0, 0, 0.85)'}}>
            <Link to={titleWrapper.url} onClick={() => this.selectTab()}>
              <Row type="flex" justify="center">
                <div className="home_title">
                  {titleWrapper.children.map(getChildrenToRender)}
                </div>
              </Row>
            </Link>
          </div>
          <OverPack {...overPackData}>
            <Row type="flex" justify="space-between">
              {childWrapper.children.map((block, i) => {
                const { children: item, ...blockProps } = block;
                return (
                    <Col key={i.toString()} {...blockProps}>
                      <Link to={{ pathname: '/customerCase' , state: { name: item.positions }}} style={{ color: '#919191' }}>
                        <div {...item}>
                          {item.children.map(getChildrenToRender)}
                        </div>
                      </Link>
                    </Col>
                );
              })}
            </Row>
          </OverPack>
        </div>
      </div>
    );
  }
}

export default Content;
